import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CircleLoader from 'common/components/elements/loader/circle';

const ImageContent = ({
   src,
   title,
   timeLeft,
   date,
   timeSector,
   commentsCount,
   showTimeLeft,
   hasAccess,
   isLiked,
   onClickComment,
   onClickLike,
   onClickShare,
   onClose,
   isAdmin,
   onDeleteStory,
   hideAfterMinutes,
   isAuthUsers,
   isMultiple,
   onDeleteImage,
   siteInfo,
   isLockedForSFW,
}) => {
   const [imageLoading, setImageLoading] = useState(false);

   useEffect(() => {
      const img = new Image();
      const eventListener = () => { setImageLoading(true); };
      img.addEventListener('load', eventListener, false);
      img.src = src;
      return () => img.removeEventListener('load', eventListener)
   }, [src]);

   return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <div className='max-h-screen h-screen relative z-10 w-full' >
         <div
            style={ {
               backgroundImage: `url(${ src })`,
               filter: isLockedForSFW ? 'blur(32px)' : '',
            } }
            className='w-full h-full bg-transparent z-30 relative  m-auto leading-none flex flex-col justify-between items-center bg-no-repeat bg-center bg-contain'
         >
            {
               !imageLoading && (
                  <div style={ { height: '100%' } } className='absolute inset-0 bg-secondary flex items-center justify-center w-full'>
                     <CircleLoader color='major-dark' />
                  </div>
               )
            }
         </div>
         <div className='flex flex-col px-4 pt-2 z-15'>
            {
               title && (
                  <h6 className='text-xl text-major-dark font-bold leading-tight mb-2 select-none threeLine'>{ title }</h6>
               )
            }
         </div>
         <div
            className='absolute inset-0 h-full bg-center w-full bg-cover z-10'
            style={ {
               filter: 'blur(36px)',
               backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 20.05%) , url(${ src })`,
            } }
         />
      </div>
   );
};

ImageContent.propTypes = {
   title: PropTypes.string,
   src: PropTypes.any,
   timeLeft: PropTypes.string,
   date: PropTypes.string,
   timeSector: PropTypes.number,
   commentsCount: PropTypes.number,
   showTimeLeft: PropTypes.bool,
   onClose: PropTypes.func,
   hasAccess: PropTypes.bool,
   isLiked: PropTypes.bool,
   onClickComment: PropTypes.func,
   onClickLike: PropTypes.func,
   onClickShare: PropTypes.func,
   onDeleteStory: PropTypes.func,
   onDeleteImage: PropTypes.func,
   isAdmin: PropTypes.bool,
   hideAfterMinutes: PropTypes.number,
   isAuthUsers: PropTypes.bool,
   isMultiple: PropTypes.bool,
   siteInfo: PropTypes.object,
   isLockedForSFW: PropTypes.bool,
};

export default memo(ImageContent);
